var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":""},on:{"click":_vm.createAccProduct}},[_vm._v(" New Product ")])
}
var staticRenderFns = []

export { render, staticRenderFns }